import React from "react";
import { IconButton, Stack } from "@fluentui/react";
import SummaryTable from "./SummaryTable";
import { IAppLog, IBrand, IReport_Merchant, IReport_Receipt } from "../../../shared/interfaces/IReceipAnalyzerEntities";
import { useAppContext } from "./AppContext";
import { useSearchParams } from "react-router";
import { useNavigate } from 'react-router';
import ReceiptImage from "./ReceiptImage";

export default function History() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {appData, setAppData} = useAppContext(); // <-- get context method

    return (
        <Stack horizontalAlign="center">
            <div className="custom-grid-table-container">
                <SummaryTable
                    data={(appData?.data?.logs || []).map((item, idx) => ({ id: idx, ...item }))}
                    columns={[
                        { key: "merchant", label: "Merchant", width: "50%", total: false, sortable: true,
                            render: (_: any, item: IAppLog) => (
                                item.transaction_date.length !== 0 ?  
                                    <div className='table-cell-content' onClick={() => navigate(`/Receipt?receiptId=${item.receipt}`)} style={{ cursor: 'pointer' }}>{item.merchant}</div>
                                :
                                    <div className='table-cell-content' onClick={() => navigate(`/ReceiptImage?imageUrl=${item.receipt}`)} style={{ cursor: 'pointer', color: 'red' }}>{item.merchant}</div>
                            )
                        },
                        { key: "transaction_date", label: "Date", width: "25%", total: false, sortable: true},
                        { key: "timestamp", label: "Uploaded", width: "25%", total: false, sortable: true,
                            render: (_: any, item: IAppLog) => (
                                    <div className='table-cell-content'>{item.timestamp?.split("T")[0]}</div>
                            ), },
                    ] as any}
                    filterKeys={[]}
                    header={true}
                    total={false}    
                    rowsPerPage={15}
                />
            </div>
        </Stack>
    );
}